"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.msgTransferIBC = void 0;
var ow_1 = __importDefault(require("ow"));
var long_1 = __importDefault(require("long"));
var ow_types_1 = require("../../ow.types");
var cro_1 = require("../../../../core/cro");
var address_1 = require("../../../../utils/address");
var typeurl_1 = require("../../../common/constants/typeurl");
exports.msgTransferIBC = function (config) {
    return (function () {
        function MsgTransfer(options) {
            ow_1.default(options, 'options', ow_types_1.owMsgTransferIBCOptions);
            this.sourcePort = options.sourcePort;
            this.sourceChannel = options.sourceChannel;
            this.token = options.token;
            this.sender = options.sender;
            this.receiver = options.receiver;
            this.timeoutHeight = options.timeoutHeight;
            this.timeoutTimestampInNanoSeconds = options.timeoutTimestampInNanoSeconds;
            this.validateAddresses();
        }
        MsgTransfer.prototype.toRawMsg = function () {
            var _a;
            return {
                typeUrl: typeurl_1.COSMOS_MSG_TYPEURL.ibc.MsgTransfer,
                value: {
                    sourcePort: this.sourcePort,
                    sourceChannel: this.sourceChannel,
                    token: (_a = this.token) === null || _a === void 0 ? void 0 : _a.toCosmosCoin(),
                    sender: this.sender,
                    receiver: this.receiver,
                    timeoutHeight: this.timeoutHeight,
                    timeoutTimestamp: this.timeoutTimestampInNanoSeconds,
                },
            };
        };
        MsgTransfer.prototype.toRawAminoMsg = function () {
            var _a, _b;
            var tokenCoin = this.token ? this.token.toCosmosCoin() : undefined;
            var timeoutHeight = this.timeoutHeight
                ? {
                    revision_number: (_a = this.timeoutHeight) === null || _a === void 0 ? void 0 : _a.revisionNumber.toString(),
                    revision_height: (_b = this.timeoutHeight) === null || _b === void 0 ? void 0 : _b.revisionHeight.toString(),
                }
                : undefined;
            return {
                type: 'cosmos-sdk/MsgTransfer',
                value: {
                    source_port: this.sourcePort,
                    source_channel: this.sourceChannel,
                    token: tokenCoin,
                    sender: this.sender,
                    receiver: this.receiver,
                    timeout_height: timeoutHeight,
                    timeout_timestamp: this.timeoutTimestampInNanoSeconds.toString(),
                },
            };
        };
        MsgTransfer.fromCosmosMsgJSON = function (msgJsonStr) {
            var _a, _b;
            var parsedMsg = JSON.parse(msgJsonStr);
            var cro = cro_1.CroSDK({ network: config.network });
            if (parsedMsg['@type'] !== typeurl_1.COSMOS_MSG_TYPEURL.ibc.MsgTransfer) {
                throw new Error("Expected " + typeurl_1.COSMOS_MSG_TYPEURL.ibc.MsgTransfer + " but got " + parsedMsg['@type']);
            }
            if (!parsedMsg.token || Object.keys(parsedMsg.token).length !== 2) {
                throw new Error('Invalid `token` in the Msg.');
            }
            var timeoutHeight;
            if (typeof parsedMsg.timeout_height === 'object') {
                timeoutHeight = {
                    revisionHeight: long_1.default.fromString((_a = parsedMsg.timeout_height) === null || _a === void 0 ? void 0 : _a.revision_height),
                    revisionNumber: long_1.default.fromString((_b = parsedMsg.timeout_height) === null || _b === void 0 ? void 0 : _b.revision_number),
                };
            }
            if (typeof parsedMsg.timeout_timestamp === 'undefined') {
                throw new Error('Invalid `timeout_timestamp` in the Msg.');
            }
            return new MsgTransfer({
                sourcePort: parsedMsg.source_port,
                sourceChannel: parsedMsg.source_channel,
                token: cro.v2.CoinV2.fromCustomAmountDenom(parsedMsg.token.amount, parsedMsg.token.denom),
                sender: parsedMsg.sender,
                receiver: parsedMsg.receiver,
                timeoutTimestampInNanoSeconds: long_1.default.fromString(parsedMsg.timeout_timestamp),
                timeoutHeight: timeoutHeight,
            });
        };
        MsgTransfer.prototype.validateAddresses = function () {
            if (!address_1.validateAddress({
                address: this.sender,
                network: config.network,
                type: address_1.AddressType.USER,
            })) {
                throw new TypeError('Provided `sender` does not match network selected');
            }
            if (!address_1.isValidBech32Address(this.receiver)) {
                throw new TypeError('Provided `receiver` is not a valid Bech-32 encoded address');
            }
        };
        return MsgTransfer;
    }());
};
//# sourceMappingURL=MsgTransfer.js.map